var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height"},[_c('q-card',{staticClass:"full-width full-height"},[_c('q-card-actions',{staticClass:"bg-accent text-white q-pa-md"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.formData.hasOwnProperty("name") && _vm.formData.name ? _vm.formData.name : "Source")+" ")]),_c('q-space'),_c('q-btn',{staticClass:"q-mr-sm sustainability-button",staticStyle:{"width":"100px","background-color":"#6dbf50"},attrs:{"loading":_vm.isLoading},on:{"click":function($event){return _vm.save(false, true)}}},[_vm._v(" Save & Add New ")]),_c('q-btn',{staticClass:"q-mr-sm sustainability-button",staticStyle:{"width":"100px"},attrs:{"color":"primary","loading":_vm.isLoading},on:{"click":function($event){return _vm.save(true, false)}}},[_vm._v(" Save & Close ")]),_c('q-btn',{attrs:{"flat":"","icon":"mdi-close","size":"5","round":""},on:{"click":_vm.closeDialog}})],1),_c('q-card-section',{staticClass:"q-pa-none"},[_c('q-tabs',{attrs:{"align":"left"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},_vm._l((_vm.tabsList),function(tabItem,i){return _c('q-tab',{key:i,attrs:{"name":tabItem.name}},[_c('div',{staticStyle:{"display":"inline"}},[_c('span',{staticClass:"tabTitle"},[_vm._v(_vm._s(tabItem.label)+" ")]),(tabItem.isError)?_c('q-icon',{attrs:{"name":"mdi-alert-circle","color":"red"}}):_vm._e()],1)])}),1),_c('q-tab-panels',{ref:"tabs",attrs:{"animated":"","keep-alive":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('q-tab-panel',{attrs:{"name":"general"}},[_c('div',{staticClass:"row q-mb-sm items-center q-mt-none"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"title q-my-none"},[_vm._v(" Source Specific "),_c('div',{staticClass:"q-px-sm",staticStyle:{"width":"100px","display":"inline-block"}},[_c('q-select',{attrs:{"label":"Type","options":['data', 'scale'],"rules":[(v) => !!v || 'Type is required']},scopedSlots:_vm._u([{key:"no-option",fn:function(){return [_c('q-item',[_c('q-item-section',{staticClass:"text-grey"},[_vm._v(" No results ")])],1)]},proxy:true}]),model:{value:(_vm.formData.type),callback:function ($$v) {_vm.$set(_vm.formData, "type", $$v)},expression:"formData.type"}})],1)])])]),_c('div',{staticClass:"row"},[_c('span',{staticClass:"text-grey",staticStyle:{"max-width":"600px"}},[_vm._v(" This is the image used as the stock image default for Sources. It often shows up in reports when someone has created a data goal. Please make it slightly different than the image below ")])]),_c('q-form',{ref:"form"},[_c('div',{staticClass:"row q-my-sm"},[_c('div',{staticClass:"col-auto q-pa-sm"},[(
                    (_vm.sourceChangeImage || !_vm.formData.imageUrl) && _vm.formData.id
                  )?_c('div',[_c('div',{staticStyle:{"width":"300px"}},[_c('croppa',{ref:"imgCroppa",attrs:{"height":200,"width":300,"remove-button-color":"#68c6d2","show-loading":true,"loading-size":50,"crossOrigin":"anonymous","quality":2,"prevent-white-space":false},model:{value:(_vm.sourceMyCroppa),callback:function ($$v) {_vm.sourceMyCroppa=$$v},expression:"sourceMyCroppa"}})],1),_c('span',{staticClass:"text-caption"},[_vm._v(" Recommended .jpg/.jpeg files and ideally 500Kb ")])]):_c('div',{staticStyle:{"width":"300px","margin":"auto"}},[(_vm.formData.id)?_c('q-img',{staticStyle:{"width":"300px","height":"200px"},attrs:{"src":_vm.formData.imageUrl}}):_vm._e(),(_vm.formData.id)?_c('q-btn',{staticClass:"full-width",attrs:{"color":"primary","label":"Change"},on:{"click":function($event){_vm.sourceChangeImage = true}}}):_vm._e(),_c('span',{staticClass:"text-caption"},[_vm._v("Recommended .jpg/.jpeg files and ideally 500Kb ")])],1)]),_c('div',{staticClass:"col q-pa-sm"},[_c('div',{staticClass:"row q-col-gutter-y-lg"},[_c('div',{staticClass:"col-4 q-px-sm"},[_c('q-input',{attrs:{"label":"Source name","rules":[(v) => !!v || 'Name is Required']},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_c('div',{staticClass:"col-4"},[_c('q-input',{attrs:{"label":"Hover Field","hint":"This will show when you hover a source title"},model:{value:(_vm.formData.hoverField),callback:function ($$v) {_vm.$set(_vm.formData, "hoverField", $$v)},expression:"formData.hoverField"}})],1),(_vm.formData.type != 'scale')?_c('div',{staticClass:"col-4 q-px-sm"},[_c('q-select',{attrs:{"label":"Unit","options":_vm.filteredUnitsList,"option-label":"name","option-value":"id","map-options":"","emit-value":"","rules":[(v) => !!v || 'Unit is required']},on:{"filter":_vm.filterUnits},scopedSlots:_vm._u([{key:"no-option",fn:function(){return [_c('q-item',[_c('q-item-section',{staticClass:"text-grey"},[_vm._v(" No results ")])],1)]},proxy:true}],null,false,2131674287),model:{value:(_vm.formData.sourcesUnits_id),callback:function ($$v) {_vm.$set(_vm.formData, "sourcesUnits_id", $$v)},expression:"formData.sourcesUnits_id"}})],1):_vm._e(),(_vm.formData.type == 'data')?_c('div',{staticClass:"col-12 col-sm-6 q-px-sm"},[_c('Autocomplete',{attrs:{"label":"File under Parent Source","id":_vm.formData.parent_id,"items":_vm.sourceList},on:{"changed":(val) => (_vm.formData.parent_id = val)}})],1):_vm._e(),(_vm.formData.type == 'scale')?_c('div',{staticClass:"col-sm-6 q-px-sm"},[_c('q-input',{attrs:{"label":"Rank","hint":"This field will rank the Scale Question in order, 1 onwards"},model:{value:(_vm.formData.rank),callback:function ($$v) {_vm.$set(_vm.formData, "rank", $$v)},expression:"formData.rank"}})],1):_vm._e(),_c('div',{staticClass:"col-12 col-sm-6 q-px-sm"},[_c('q-select',{attrs:{"options":['draft', 'live'],"label":"Status"},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}})],1),_c('div',{staticClass:"col-12"},[_c('q-checkbox',{attrs:{"label":"Negative Source","true-value":1,"false-value":0},model:{value:(_vm.formData.negative),callback:function ($$v) {_vm.$set(_vm.formData, "negative", $$v)},expression:"formData.negative"}}),(_vm.formData.id)?_c('q-btn',{staticClass:"bg-primary q-ml-md text-white",attrs:{"label":"Duplicate Positive Source","flat":"","loading":_vm.creatingPositiveSourceLoading},on:{"click":function($event){return _vm.createPositiveSource(_vm.formData.id)}}}):_vm._e()],1),_c('div',{staticClass:"col-12"},[(_vm.formData.type == 'scale')?_c('q-input',{staticClass:"q-mb-lg",attrs:{"label":"Question (Scale Only)","type":"textarea"},model:{value:(_vm.formData.question),callback:function ($$v) {_vm.$set(_vm.formData, "question", $$v)},expression:"formData.question"}}):_vm._e()],1)])]),_c('div',{staticClass:"col-12"},[_c('q-input',{staticClass:"q-mb-lg",attrs:{"label":"Admin Notes","type":"textarea"},model:{value:(_vm.formData.adminNotes),callback:function ($$v) {_vm.$set(_vm.formData, "adminNotes", $$v)},expression:"formData.adminNotes"}})],1),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"text-bold"},[_vm._v("Info Blurb (Side Popout)")]),_c('q-editor',{attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                    [
                      {
                        label: _vm.$q.lang.editor.align,
                        icon: _vm.$q.iconSet.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify'],
                      },
                    ],
                    [
                      'bold',
                      'italic',
                      'strike',
                      'underline',
                      'subscript',
                      'superscript',
                    ],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    [
                      {
                        label: _vm.$q.lang.editor.formatting,
                        icon: _vm.$q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                          'p',
                          'h1',
                          'h2',
                          'h3',
                          'h4',
                          'h5',
                          'h6',
                          'code',
                        ],
                      },
                      {
                        label: _vm.$q.lang.editor.fontSize,
                        icon: _vm.$q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'size-1',
                          'size-2',
                          'size-3',
                          'size-4',
                          'size-5',
                          'size-6',
                          'size-7',
                        ],
                      },

                      'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                    ['undo', 'redo'],
                    ['viewsource'],
                  ]},model:{value:(_vm.formData.infoBlurb),callback:function ($$v) {_vm.$set(_vm.formData, "infoBlurb", $$v)},expression:"formData.infoBlurb"}})],1)])])],1),_c('q-tab-panel',{attrs:{"name":"outcomes"}},[_c('div',{staticClass:"row q-mb-sm items-center"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row items-center q-col-gutter-x-md"},[_c('div',{staticClass:"title q-my-none q-mx-none"},[_vm._v("Outcomes")]),_c('div',{staticStyle:{"width":"200px"}},[_c('q-form',{ref:"outcomeForm"},[_c('q-select',{attrs:{"options":_vm.filteredOutcomesList,"label":"Outcome","map-options":"","emit-value":"","option-value":"id","option-label":"name"},model:{value:(_vm.selectedOutcome),callback:function ($$v) {_vm.selectedOutcome=$$v},expression:"selectedOutcome"}})],1)],1),_c('div',[_c('q-btn',{attrs:{"disabled":!_vm.selectedOutcome,"color":"primary"},on:{"click":_vm.addOutcome}},[_c('q-icon',{attrs:{"name":"mdi-plus-circle"}}),_c('span',{staticClass:"sustainability-font q-mx-sm"},[_vm._v(" Add ")])],1)],1)])]),_c('div',{staticClass:"col-3"},[_c('q-input',{staticClass:"searchbar float-right",staticStyle:{"max-width":"70%"},attrs:{"filled":"","debounce":"200","label":"Search","clearable":"","dense":""},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('q-icon',{attrs:{"name":"mdi-magnify"}})]},proxy:true}]),model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)]),(
              _vm.outcomesSourcesList.length == 0 ||
              _vm.outcomesSourcesList[0].sources_id == _vm.formData.id
            )?_c('data-table',{staticStyle:{"height":"calc(100vh - 270px)"},attrs:{"headerBgColor":"#162c47","headerTextColor":"white","columns":_vm.columns,"data":_vm.outcomesSourcesList,"flat":"","filter":_vm.searchText},scopedSlots:_vm._u([{key:"body-cell-categoryName",fn:function(data){return [_c('q-td',{attrs:{"props":data.props}},[_c('q-select',{staticStyle:{"max-width":"400px"},attrs:{"use-input":"","fill-input":"","dense":"","hide-selected":"","color":"accent","input-debounce":"0","label":"Category","options":_vm.categoryOptions,"map-options":"","emit-value":"","option-label":"name"},on:{"blur":function($event){return _vm.submitCategory(
                      data.props.row,
                      data.props.row.categoryName
                    )},"popup-show":function($event){return _vm.filterCategoryOptionsByOutcome(data.props.row)},"filter":(val, update, abort) =>
                      _vm.filterCategory(val, update, abort, data.props.row)},scopedSlots:_vm._u([{key:"no-option",fn:function(){return [_c('q-item',[_c('q-item-section',{staticClass:"text-grey"},[_vm._v(" No results ")])],1)]},proxy:true}],null,true),model:{value:(data.props.row.categoryName),callback:function ($$v) {_vm.$set(data.props.row, "categoryName", $$v)},expression:"data.props.row.categoryName"}})],1)]}},{key:"body-cell-actions",fn:function(data){return [_c('q-td',{attrs:{"props":data.props}},[_c('q-btn',{staticClass:"float-right",attrs:{"round":"","color":"red","flat":"","icon":"mdi-delete","size":"md"},on:{"click":function($event){return _vm.removeOutcome(data.props.row)}}},[_c('q-tooltip',{attrs:{"content-class":"bg-accent","offset":[10, 10]}},[_vm._v(" Remove Outcome ")])],1)],1)]}}],null,false,1453934837)}):_vm._e()],1),_c('q-tab-panel',{attrs:{"name":"reference"}},[(!_vm.isAddingReference)?_c('div',[_c('div',{staticClass:"row q-mb-sm items-center"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row items-center q-col-gutter-x-md"},[_c('div',{staticClass:"title q-my-none q-mx-none"},[_vm._v("Reference")]),_c('div',[_c('q-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.isAddingReference = true}}},[_c('q-icon',{attrs:{"name":"mdi-plus-circle"}}),_c('span',{staticClass:"sustainability-font q-mx-sm"},[_vm._v(" Add ")])],1)],1)])]),_c('div',{staticClass:"col-3"},[_c('q-input',{staticClass:"searchbar float-right",staticStyle:{"max-width":"70%"},attrs:{"filled":"","debounce":"200","label":"Search","clearable":"","dense":""},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('q-icon',{attrs:{"name":"mdi-magnify"}})]},proxy:true}],null,false,2453493074),model:{value:(_vm.referenceSearchText),callback:function ($$v) {_vm.referenceSearchText=$$v},expression:"referenceSearchText"}})],1)]),_c('data-table',{staticStyle:{"height":"calc(100vh - 270px)"},attrs:{"columns":_vm.referenceColumns,"filter":_vm.referenceSearchText,"data":_vm.referenceList,"headerBgColor":"#162c47","headerTextColor":"white"},on:{"rowDoubleClick":_vm.referenceDoubleClick},scopedSlots:_vm._u([{key:"body-cell-actions",fn:function(data){return [_c('q-td',{attrs:{"props":data.props}},[_c('q-btn',{staticClass:"float-right",attrs:{"round":"","color":"red","flat":"","icon":"mdi-delete","size":"md"},on:{"click":function($event){return _vm.removeReference(data.props.row)}}},[_c('q-tooltip',{attrs:{"content-class":"bg-accent","offset":[10, 10]}},[_vm._v(" Remove Reference ")])],1)],1)]}}],null,false,509641017)})],1):_c('div',[_c('div',{staticClass:"row q-mb-sm items-center"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row items-center q-col-gutter-x-md"},[_c('div',[_c('q-btn',{attrs:{"flat":""},on:{"click":_vm.backFromReferenceForm}},[_c('q-icon',{attrs:{"name":"mdi-arrow-left"}})],1)],1),_c('div',{staticClass:"title q-my-none q-mx-none"},[_vm._v("Reference")])])])]),_c('div',{staticClass:"row q-mt-lg"},[_c('div',{staticClass:"col-12"},[_c('reference-form',{on:{"closeForm":_vm.backFromReferenceForm}})],1)])])]),_c('q-tab-panel',{attrs:{"name":"solutions"}},[_c('div',{staticClass:"row q-mb-sm items-center"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row items-center q-col-gutter-x-md"},[_c('div',{staticClass:"title q-my-none q-mx-none"},[_vm._v("Solutions")]),_c('div',{staticStyle:{"width":"200px"}},[_c('q-form',{ref:"outcomeForm"},[_c('q-select',{attrs:{"options":_vm.filteredSolutionsOptions,"label":"Solution","use-input":"","fill-input":"","hide-selected":"","map-options":"","emit-value":"","option-value":"id","option-label":"title"},on:{"filter":_vm.solutionFilterFn},model:{value:(_vm.selectedSolution),callback:function ($$v) {_vm.selectedSolution=$$v},expression:"selectedSolution"}})],1)],1),_c('div',[_c('q-btn',{attrs:{"disabled":!_vm.selectedSolution,"color":"primary"},on:{"click":_vm.addSolutionSources}},[_c('q-icon',{attrs:{"name":"mdi-plus-circle"}}),_c('span',{staticClass:"sustainability-font q-mx-sm"},[_vm._v(" Add ")])],1)],1)])]),_c('div',{staticClass:"col-3"},[_c('q-input',{staticClass:"searchbar float-right",staticStyle:{"max-width":"70%"},attrs:{"filled":"","debounce":"200","label":"Search","clearable":"","dense":""},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('q-icon',{attrs:{"name":"mdi-magnify"}})]},proxy:true}]),model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)]),_c('data-table',{staticStyle:{"height":"calc(100vh - 270px)"},attrs:{"headerBgColor":"#162c47","headerTextColor":"white","columns":_vm.solutionsColumns,"data":_vm.solutionsList,"flat":"","filter":_vm.searchText},scopedSlots:_vm._u([{key:"body-cell-actions",fn:function(data){return [_c('q-td',{attrs:{"props":data.props}},[_c('q-btn',{staticClass:"float-right",attrs:{"round":"","color":"red","flat":"","icon":"mdi-delete","size":"md"},on:{"click":function($event){return _vm.removeSolutionSources(data.props.row)}}},[_c('q-tooltip',{attrs:{"content-class":"bg-accent","offset":[10, 10]}},[_vm._v(" Remove Solution ")])],1)],1)]}}])})],1),_c('q-tab-panel',{attrs:{"name":"scaleNotes"}},[_c('div',{staticClass:"row q-my-sm"},[_c('div',{staticClass:"col-12 col-md-6 q-px-sm"},[_c('p',{staticClass:"text-bold"},[_vm._v("Scale Level 1 Note")]),_c('q-editor',{attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                  [
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify'],
                    },
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      options: ['left', 'center', 'right', 'justify'],
                    },
                  ],
                  [
                    'bold',
                    'italic',
                    'strike',
                    'underline',
                    'subscript',
                    'superscript',
                  ],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['print', 'fullscreen'],
                  [
                    {
                      label: _vm.$q.lang.editor.formatting,
                      icon: _vm.$q.iconSet.editor.formatting,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.fontSize,
                      icon: _vm.$q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.defaultFont,
                      icon: _vm.$q.iconSet.editor.font,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'default_font',
                        'arial',
                        'arial_black',
                        'comic_sans',
                        'courier_new',
                        'impact',
                        'lucida_grande',
                        'times_new_roman',
                        'verdana',
                      ],
                    },
                    'removeFormat',
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                  ['undo', 'redo'],
                  ['viewsource'],
                ],"fonts":{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana',
                }},model:{value:(_vm.formData.scaleLevel1Notes),callback:function ($$v) {_vm.$set(_vm.formData, "scaleLevel1Notes", $$v)},expression:"formData.scaleLevel1Notes"}})],1),_c('div',{staticClass:"col-12 col-md-6 q-px-sm"},[_c('p',{staticClass:"text-bold"},[_vm._v("Scale Level 2 Note")]),_c('q-editor',{attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                  [
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify'],
                    },
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      options: ['left', 'center', 'right', 'justify'],
                    },
                  ],
                  [
                    'bold',
                    'italic',
                    'strike',
                    'underline',
                    'subscript',
                    'superscript',
                  ],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['print', 'fullscreen'],
                  [
                    {
                      label: _vm.$q.lang.editor.formatting,
                      icon: _vm.$q.iconSet.editor.formatting,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.fontSize,
                      icon: _vm.$q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.defaultFont,
                      icon: _vm.$q.iconSet.editor.font,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'default_font',
                        'arial',
                        'arial_black',
                        'comic_sans',
                        'courier_new',
                        'impact',
                        'lucida_grande',
                        'times_new_roman',
                        'verdana',
                      ],
                    },
                    'removeFormat',
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                  ['undo', 'redo'],
                  ['viewsource'],
                ],"fonts":{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana',
                }},model:{value:(_vm.formData.scaleLevel2Notes),callback:function ($$v) {_vm.$set(_vm.formData, "scaleLevel2Notes", $$v)},expression:"formData.scaleLevel2Notes"}})],1),_c('div',{staticClass:"col-12 col-md-6 q-px-sm"},[_c('p',{staticClass:"text-bold"},[_vm._v("Scale Level 3 Note")]),_c('q-editor',{attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                  [
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify'],
                    },
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      options: ['left', 'center', 'right', 'justify'],
                    },
                  ],
                  [
                    'bold',
                    'italic',
                    'strike',
                    'underline',
                    'subscript',
                    'superscript',
                  ],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['print', 'fullscreen'],
                  [
                    {
                      label: _vm.$q.lang.editor.formatting,
                      icon: _vm.$q.iconSet.editor.formatting,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.fontSize,
                      icon: _vm.$q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.defaultFont,
                      icon: _vm.$q.iconSet.editor.font,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'default_font',
                        'arial',
                        'arial_black',
                        'comic_sans',
                        'courier_new',
                        'impact',
                        'lucida_grande',
                        'times_new_roman',
                        'verdana',
                      ],
                    },
                    'removeFormat',
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                  ['undo', 'redo'],
                  ['viewsource'],
                ],"fonts":{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana',
                }},model:{value:(_vm.formData.scaleLevel3Notes),callback:function ($$v) {_vm.$set(_vm.formData, "scaleLevel3Notes", $$v)},expression:"formData.scaleLevel3Notes"}})],1),_c('div',{staticClass:"col-12 col-md-6 q-px-sm"},[_c('p',{staticClass:"text-bold"},[_vm._v("Scale Level 4 Note")]),_c('q-editor',{attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                  [
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify'],
                    },
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      options: ['left', 'center', 'right', 'justify'],
                    },
                  ],
                  [
                    'bold',
                    'italic',
                    'strike',
                    'underline',
                    'subscript',
                    'superscript',
                  ],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['print', 'fullscreen'],
                  [
                    {
                      label: _vm.$q.lang.editor.formatting,
                      icon: _vm.$q.iconSet.editor.formatting,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.fontSize,
                      icon: _vm.$q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.defaultFont,
                      icon: _vm.$q.iconSet.editor.font,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'default_font',
                        'arial',
                        'arial_black',
                        'comic_sans',
                        'courier_new',
                        'impact',
                        'lucida_grande',
                        'times_new_roman',
                        'verdana',
                      ],
                    },
                    'removeFormat',
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                  ['undo', 'redo'],
                  ['viewsource'],
                ],"fonts":{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana',
                }},model:{value:(_vm.formData.scaleLevel4Notes),callback:function ($$v) {_vm.$set(_vm.formData, "scaleLevel4Notes", $$v)},expression:"formData.scaleLevel4Notes"}})],1),_c('div',{staticClass:"col-12 col-md-6 q-px-sm"},[_c('p',{staticClass:"text-bold"},[_vm._v("Scale Level 5 Note")]),_c('q-editor',{attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                  [
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify'],
                    },
                    {
                      label: _vm.$q.lang.editor.align,
                      icon: _vm.$q.iconSet.editor.align,
                      fixedLabel: true,
                      options: ['left', 'center', 'right', 'justify'],
                    },
                  ],
                  [
                    'bold',
                    'italic',
                    'strike',
                    'underline',
                    'subscript',
                    'superscript',
                  ],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['print', 'fullscreen'],
                  [
                    {
                      label: _vm.$q.lang.editor.formatting,
                      icon: _vm.$q.iconSet.editor.formatting,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.fontSize,
                      icon: _vm.$q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7',
                      ],
                    },
                    {
                      label: _vm.$q.lang.editor.defaultFont,
                      icon: _vm.$q.iconSet.editor.font,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'default_font',
                        'arial',
                        'arial_black',
                        'comic_sans',
                        'courier_new',
                        'impact',
                        'lucida_grande',
                        'times_new_roman',
                        'verdana',
                      ],
                    },
                    'removeFormat',
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                  ['undo', 'redo'],
                  ['viewsource'],
                ],"fonts":{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana',
                }},model:{value:(_vm.formData.scaleLevel5Notes),callback:function ($$v) {_vm.$set(_vm.formData, "scaleLevel5Notes", $$v)},expression:"formData.scaleLevel5Notes"}})],1)])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }